import * as React from "react";
// import PropTypes from "prop-types";
// import Box from "@mui/material/Box";
import Sidebar from "./sidebar";

function Test() {
  return <Sidebar title={"dashboar"}>Test1</Sidebar>;
}

export default Test;
